import moment from 'moment'

export const verifyParamsActionGetListTransHistoryByUser = (params) => {
    const { ID, PageSize, PageNumber, FacepayNumber, Shop, Amount, Time } = params

    if (!ID) throw Error('ID is obligated')
    if (typeof (ID) !== 'string') throw Error('ID must be a string')

    if (!PageNumber) throw Error('PageNumber is obligated')
    if (typeof (PageNumber) !== 'number') throw Error('PageNumber must be a number')

    if (!PageSize) throw Error('PageSize is obligated')
    if (typeof (PageSize) !== 'number') throw Error('PageSize must be a number')

    const validSortValue = [-1, 0 , 1]
    const keyValidInCompare = ["GREATER", "LESS", "GREATER_OR_EQUAL", "LESS_OR_EQUAL", "NOT_EQUAL", "EQUAL"]

    if(FacepayNumber) {
        const { Sort, No } = FacepayNumber

        if(Sort && !validSortValue.includes(Sort))
            throw Error(`FacepayNumber.Sort must be one value in {${validSortValue.join(', ')}}`)
        
        if(No && typeof(No) !== 'string')
            throw Error('FacepayNumber.No must be a string')
    }

    if(Shop) {
        const { Sort, ShopName } = Shop

        if(Sort && !validSortValue.includes(Sort))
            throw Error(`Shop.Sort must be one value in {${validSortValue.join(', ')}}`)
        
        if(ShopName && typeof(ShopName) !== 'string')
            throw Error('Shop.ShopName must be a string')
    }

    if(Amount){
        const { Sort, Comparers } = Amount

        if(Sort && !validSortValue.includes(Sort)) {
            throw Error(`Amount.Sort must be one value in {${validSortValue.join(', ')}} but ${Sort}`)
        }

        if(Comparers) {
            if(!Array.isArray(Comparers)) {
                throw Error(`Amount.Comparers must be an array`)
            }

            Comparers.forEach(item => {
                if(!item || typeof(item) !== "object") {
                    throw Error('item in list Amount.Comparers must be an object')
                }
                const { Operator, Value } = item
                if(!keyValidInCompare.includes(Operator)) {
                    throw Error(`Amount.Comparers[item].Operator must be one value in {${keyValidInCompare.join(", ")}}`)
                }

                if(Value !== 0 && typeof(Value) !== "number"){
                    throw Error(`Amount.Comparers[item].Value must be a number but ${typeof(Value)}`)
                }
            })
        }
    }

    if(Time) {
        const { Sort, FromDate, ToDate } = Time

        if(Sort && !validSortValue.includes(Sort))
            throw Error(`Time.Sort must be one value in {-1, 0, 1}`)
        
        if(FromDate && typeof(FromDate) !== 'string') {
            throw Error(`Time.FromDate must be a string but ${typeof(FromDate)}`)
        }

        if(FromDate && !moment(FromDate, 'YYYY/MM/DD', true).isValid()) {
            throw Error(`Time.FromDate must format YYYY/MM/DD but ${typeof(FromDate)}`)
        }

        if(ToDate && typeof(ToDate) !== 'string')
            throw Error(`Time.ToDate must be a string but ${typeof(ToDate)}`)

        if(ToDate && !moment(ToDate, 'YYYY/MM/DD', true).isValid()) {
            throw Error(`Time.ToDate must format YYYY/MM/DD but ${typeof(ToDate)}`)
        }
    }
}